import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { promoPreviewHtmlFor } from "@/lib/api";

// Live preview of the two personalised pages (welcome + closing) rendered from the real template.
export function PromoPreview({ form, templateId }) {
  const [sec, setSec] = useState("intro");
  const [html, setHtml] = useState("");
  const [nonce, setNonce] = useState(0);
  const [scale, setScale] = useState(300 / 720);
  const boxRef = useRef(null);
  useEffect(() => {
    const el = boxRef.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(() => setScale(el.clientWidth / 720));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  useEffect(() => {
    let alive = true;
    const t = setTimeout(() => promoPreviewHtmlFor(form, sec, templateId).then((h) => alive && setHtml(h)).catch(() => {}), 350);
    return () => { alive = false; clearTimeout(t); };
  }, [form, sec, nonce, templateId]);
  return (
    <div className="rounded-2xl border border-zinc-200 bg-white p-4 space-y-3" data-testid="promo-preview">
      <div className="flex items-center justify-between">
        <div className="text-xs font-semibold text-zinc-900"><span className="inline-flex h-5 w-5 rounded-full bg-zinc-900 text-white text-[11px] items-center justify-center mr-2">3</span>Preview</div>
        <div className="inline-flex rounded-full bg-zinc-100 p-0.5 text-xs font-semibold">
          {[["intro", "Welcome page"], ["close", "Closing page"]].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setSec(k)} className={`px-3 h-7 rounded-full ${sec === k ? "bg-white shadow text-zinc-900" : "text-zinc-500"}`} data-testid={`promo-preview-${k}`}>{l}</button>
          ))}
        </div>
        <button type="button" onClick={() => setNonce((n) => n + 1)} className="h-7 w-7 rounded-full border border-zinc-200 inline-flex items-center justify-center text-zinc-500 hover:bg-zinc-50" title="Replay" data-testid="promo-preview-replay"><RefreshCw size={12} /></button>
      </div>
      <div ref={boxRef} className="mx-auto w-full max-w-[300px] aspect-[9/16] rounded-[22px] overflow-hidden bg-black ring-4 ring-zinc-900 relative">
        {html ? <iframe title="preview" srcDoc={html} className="absolute left-0 top-0 origin-top-left border-0" style={{ width: 720, height: 1280, transform: `scale(${scale})` }} data-testid="promo-preview-frame" /> : null}
      </div>
      <p className="text-[11px] text-zinc-400 text-center">The commercial itself plays untouched between your welcome and closing pages.</p>
    </div>
  );
}
